export function clsx(...args: Array<string | undefined>) {
  return args.filter(Boolean).join(" ");
}

export const transition = (prop: string[] | string) => {
  const params = "0.2s ease-out";
  return Array.isArray(prop)
    ? `${prop.map((p) => `${p} ${params}`).join(",")}`
    : `${prop} ${params}`;
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function exportToCSV(data: string[][], filename = "export.csv") {
  if (!data?.length) {
    return;
  }

  const headers = data[0];
  const csvRows = [];

  // Add headers
  csvRows.push(headers.join(","));

  // Add rows
  data.forEach((row) => {
    const values = headers.map((_, index) => {
      const val = row[index];
      // Escape double quotes by doubling them, and wrap the value in double quotes
      const escaped = ("" + val).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
